import type { AvatarUploaderProps } from '../AvatarUploader/index.ts';
import type { FormComponentProps } from './types.ts';
import { AvatarUploader } from '../AvatarUploader/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { useMergeHandleChangeAndBlur, usePropsFromField } from './utils.ts';

export function FormAvatarUploader(
  props: FormComponentProps<Omit<AvatarUploaderProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<File | null>();

  const handleChangeAndBlur = useMergeHandleChangeAndBlur(field.handleChange, field.handleBlur);

  return (
    <AvatarUploader
      key={field.name}
      {...usePropsFromField(props, field)}
      onChange={handleChangeAndBlur}
      value={field.state.value}
    />
  );
}
